import { Injectable, OnDestroy } from '@angular/core';
import { CurrentUserService } from './current-user.service';
import { UserContextService } from './user-context.service';
import { Subscription } from 'rxjs';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class SentryContextService implements OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private currentUserService: CurrentUserService,
    private userContextService: UserContextService
  ) {
    this.subscriptions.push(
      this.currentUserService.currentUser$.subscribe(user => {
        if (user?.email) {
          Sentry.setUser({
            email: user.email,
          });
        } else {
          Sentry.setUser(null);
        }
      })
    );

    this.subscriptions.push(
      this.userContextService.userContext$.subscribe(context => {
        Sentry.setContext('userContext', {
          context: context,
        });
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
